<template>
    <div class="test-page">
        <!-- Header с меню -->
        <header class="header">
            <Menubar :model="items" class="menubar">
                <template #start>
                    <h1 class="page-title">Тестовая страница</h1>
                </template>
                <template #item="{ item, props, hasSubmenu, root }">
                    <a class="menu-item" v-bind="props.action">
                        <i :class="item.icon"></i>
                        <span>{{ item.label }}</span>
                        <Badge v-if="item.badge" :class="{ 'ml-auto': !root, 'ml-2': root }" :value="item.badge" />
                        <span v-if="item.shortcut" class="shortcut">{{ item.shortcut }}</span>
                        <i v-if="hasSubmenu" :class="['pi pi-angle-down ml-auto', { 'pi-angle-down': root, 'pi-angle-right': !root }]"></i>
                    </a>
                </template>
                <template #end>
                    <div class="user-avatar">
                        <Avatar 
                            :image="userAvatar" 
                            shape="circle" 
                            size="large"
                            class="avatar"
                        />
                        <span class="username">Тестовый пользователь</span>
                    </div>
                </template>
            </Menubar>
        </header>

        <!-- Основной контент -->
        <main class="main-content">
            <!-- Информационная карточка -->
            <div class="info-card">
                <h2>Добро пожаловать на тестовую страницу!</h2>
                <p>Здесь вы можете просматривать галерею изображений и видео, а также тестировать функциональность.</p>
            </div>

            <!-- Галерея изображений -->
            <div class="gallery-section">
                <h3>Галерея изображений</h3>
                <div class="media-container">
                    <PhotoTile 
                        v-for="(photo, index) in media.photo" 
                        :key="`${photo.id}-${index}`" 
                        :photo="photo"
                    />
                </div>
            </div>

            <!-- Видеоплеер -->
            <div class="video-section">
                <h3>Видеогалерея</h3>
                <div class="video-container">
                    <div 
                        v-for="(video, index) in media.video" 
                        :key="`${video.id}-${index}`" 
                        class="video-item"
                    >
                        <div class="video-wrapper">
                            <video 
                                class="video-player" 
                                controls 
                                preload="metadata"
                                :poster="video.poster"
                            >
                                <source :src="video.src" :type="video.type">
                                Ваш браузер не поддерживает воспроизведение видео.
                            </video>
                            <div class="video-info">
                                <span class="video-title">{{ video.title }}</span>
                                <span class="video-duration">{{ video.duration }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Статистика -->
            <div class="stats-section">
                <h3>Статистика</h3>
                <div class="stats-grid">
                    <div class="stat-card">
                        <i class="pi pi-image stat-icon"></i>
                        <div class="stat-content">
                            <span class="stat-number">{{ media.photo.length }}</span>
                            <span class="stat-label">Изображений</span>
                        </div>
                    </div>
                    <div class="stat-card">
                        <i class="pi pi-video stat-icon"></i>
                        <div class="stat-content">
                            <span class="stat-number">{{ media.video.length }}</span>
                            <span class="stat-label">Видео</span>
                        </div>
                    </div>
                    <div class="stat-card">
                        <i class="pi pi-calendar stat-icon"></i>
                        <div class="stat-content">
                            <span class="stat-number">{{ new Date().getDate() }}</span>
                            <span class="stat-label">День месяца</span>
                        </div>
                    </div>
                    <div class="stat-card">
                        <i class="pi pi-clock stat-icon"></i>
                        <div class="stat-content">
                            <span class="stat-number">{{ new Date().getHours() }}:{{ new Date().getMinutes() }}</span>
                            <span class="stat-label">Время</span>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import axios from 'axios';
import Menubar from 'primevue/menubar';
import Avatar from 'primevue/avatar';   
import Badge from 'primevue/badge';
import PhotoTile from '@/components/PhotoTile.vue';

const media = ref({
    photo: [],
    video: [],
});

onMounted(async () => {
    const headers = {
        'Authorization': 'OAuth y0__xCavpHRARi5kzcgkIjs7xLqt9PoT25c7YXkmFiDTwNyHayW2A',
    };
    const params = {
        path: 'Приложения/CatchTheNowBot/706589393/photo',
        preview_size: 'L',
        fields: '_embedded.total,_embedded.items.path,_embedded.items.name,_embedded.items.created,_embedded.items.modified,_embedded.items.size,_embedded.items.preview,_embedded.items.media_type,_embedded.items.file',
    };
    const response = await axios.get('https://cloud-api.yandex.net/v1/disk/resources', { headers, params });
    
    // Преобразуем данные для совместимости с PhotoTile
    media.value.photo = response.data._embedded.items
        .filter(item => item.media_type === 'image')
        .map(item => ({
            id: item.name,
            url: item.file || item.preview,
            thumbnail: item.preview,
            alt: item.name,
            title: item.name,
            description: `Размер: ${(item.size / 1024 / 1024).toFixed(2)} MB`
        }));
    
    console.log(media.value);
});

            
</script>

<style scoped>
.test-page {
    min-height: 100vh;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.header {
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    position: sticky;
    top: 0;
    z-index: 1000;
}

.menubar {
    background: transparent !important;
    border: none !important;
    padding: 1rem 2rem !important;
}

.page-title {
    color: white;
    margin: 0;
    font-size: 1.5rem;
    font-weight: 600;
}

.menu-item {
    color: white !important;
    text-decoration: none;
    padding: 0.5rem 1rem;
    border-radius: 8px;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.menu-item:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-2px);
}

.shortcut {
    background: rgba(255, 255, 255, 0.2);
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    font-size: 0.75rem;
    margin-left: 0.5rem;
}

.user-avatar {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.avatar {
    border: 2px solid rgba(255, 255, 255, 0.3);
}

.username {
    color: white;
    font-weight: 500;
}

.main-content {
    padding: 2rem;
    max-width: 1200px;
    margin: 0 auto;
}

.info-card {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 16px;
    padding: 2rem;
    margin-bottom: 2rem;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    text-align: center;
}

.info-card h2 {
    color: #333;
    margin-bottom: 1rem;
    font-size: 2rem;
}

.info-card p {
    color: #666;
    font-size: 1.1rem;
    line-height: 1.6;
}

.gallery-section, .video-section {
    margin-bottom: 2rem;
}

.gallery-section h3, .video-section h3 {
    color: white;
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    text-align: center;
}

.media-container, .video-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 1.5rem;
    padding: 1rem;
}

/* Стили для PhotoTile компонента */
.media-container {
    align-items: start;
}

.video-item {
    position: relative;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
    aspect-ratio: 1;
}

.video-item:hover {
    transform: translateY(-8px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.25);
}

.video-wrapper {
    background: #000;
    border-radius: 12px;
    overflow: hidden;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.video-player {
    width: 100%;
    flex: 1;
    border-radius: 12px 12px 0 0;
    background: #000;
    object-fit: cover;
}

.video-info {
    padding: 1rem;
    background: rgba(255, 255, 255, 0.95);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
}

.video-title {
    font-weight: 600;
    color: #333;
}

.video-duration {
    background: rgba(102, 126, 234, 0.1);
    color: #667eea;
    padding: 0.25rem 0.75rem;
    border-radius: 12px;
    font-size: 0.875rem;
    font-weight: 500;
}

.stats-section {
    margin-bottom: 2rem;
}

.stats-section h3 {
    color: white;
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    text-align: center;
}

.stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1.5rem;
}

.stat-card {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 12px;
    padding: 1.5rem;
    text-align: center;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
}

.stat-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.stat-icon {
    font-size: 2rem;
    color: #667eea;
    margin-bottom: 1rem;
}

.stat-content {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.stat-number {
    font-size: 2rem;
    font-weight: 700;
    color: #333;
}

.stat-label {
    font-size: 0.875rem;
    color: #666;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* Адаптивность */
@media (max-width: 1200px) {
    .media-container, .video-container {
        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    }
}

@media (max-width: 992px) {
    .media-container, .video-container {
        grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    }
}

@media (max-width: 768px) {
    .main-content {
        padding: 1rem;
    }
    
    .media-container, .video-container {
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
        gap: 1rem;
    }
    
    .stats-grid {
        grid-template-columns: 1fr;
    }
    
    .menubar {
        padding: 1rem !important;
    }
    
    .page-title {
        font-size: 1.25rem;
    }
}

@media (max-width: 480px) {
    .media-container, .video-container {
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
        gap: 0.75rem;
    }
    
    .photo-item, .video-item {
        border-radius: 8px;
    }
    
    .gallery-image {
        border-radius: 8px;
    }
    
    .video-wrapper {
        border-radius: 8px;
    }
    
    .video-player {
        border-radius: 8px 8px 0 0;
    }
}
</style>